import { SearchFilter, SearchFilterOptionRange } from "../../../redux-magic/sub-interfaces/search-types";

export const _s_floors: SearchFilter = {
	id: "floors",
	title: "Floors",
	level: 3,
	index: 18,
	presentation_type: "range_text_fields",
	multi: false,
	affects: [],
	affected_by: ["property_type"],
	priority: 3,
	is_advanced: true,
	included_in_search_bar: false,
	option_type: "range",
	possible_options: [
		{
			id: "floors",
			title: "Floors",
			value: {
				min: 0,
				max: 0,
				unlock_max: true,
			},
		},
	] as Array<SearchFilterOptionRange>,
	active_options: [
		{
			id: "floors",
			title: "Floors",
			value: {
				min: 0,
				max: 0,
				unlock_max: true,
			},
		},
	] as Array<SearchFilterOptionRange>,
	selected_options: [] as Array<SearchFilterOptionRange>,
	db_collection: "properties",
	db_field: "floors",
	is_visible: false,
	is_applied: false,
	is_accordion_open: false,
};
